export const environment = {
  production: false,
  url: "https://crl-gateway-uat.api-nonprd.allianz.co.id/eform/",
  partnerIdBSI: '6799531',
  partnerIdBTPN: '6187346',
  randomNonce: '',
};
